import { Button, Grid, useSearchParams } from '@forgeglobal/design-framework';
import { object, string } from 'yup';

import {
  Field,
  FieldRenderProps,
  Form,
  FormRenderProps,
} from '@tcs/common/components/atoms/Form';
import TextField from '@tcs/common/components/atoms/TextField';
import useConfig from '@tcs/create-account/hooks/useConfig';
import { format } from 'date-fns';
import { useState } from 'react';
import { useStyles } from './style';

const RegisterForm: React.FC = () => {
  const classes = useStyles();
  const config = useConfig();
  const [searchParams] = useSearchParams();

  const [isFormValid, setIsFormValid] = useState(false);

  const onFormValidate = (isValid): void => setIsFormValid(isValid);

  const validationSchema = object({
    email: string().email().required('Required field'),
  });

  return (
    <Form
      onSubmit={
        () => null /* noop form handler so we can leverage validation only */
      }
      onValidate={onFormValidate}
      validationSchema={validationSchema}
      render={({ submitting }: FormRenderProps) => {
        return (
          validationSchema && (
            <form
              data-test-id="register-form"
              action={config.PUBLIC_PARDOT_FORM_HANDLER}
              method="POST">
              <Field
                name="trust_application_started_date"
                render={(props) => (
                  <input
                    name={props.input.name}
                    type="hidden"
                    value={format(new Date(), 'yyyy-MM-dd')}
                  />
                )}
              />
              <Field
                name="promoCode"
                render={(props) => (
                  <input
                    name={props.input.name}
                    type="hidden"
                    value={searchParams.get('promoCode')}
                  />
                )}
              />
              <Grid
                direction="column"
                container
                justifyContent="center"
                spacing={4}>
                <Grid item className={classes.gridItem}>
                  <Field
                    name="email"
                    render={(props: FieldRenderProps<string>) => (
                      <TextField
                        data-test-id="email"
                        label="Email"
                        name="email"
                        autoComplete="email"
                        className={classes.textField}
                        endAdornment={null}
                        {...props}
                      />
                    )}
                  />
                </Grid>
                <Grid
                  item
                  container
                  justifyContent="center"
                  className={classes.buttonContainer}>
                  <Button
                    data-test-id="login-button"
                    size="medium"
                    color="primary"
                    className={classes.button}
                    type="submit"
                    disabled={submitting || !isFormValid}>
                    Get Started
                  </Button>
                </Grid>
              </Grid>
            </form>
          )
        );
      }}
    />
  );
};

export default RegisterForm;
